import { createSelector } from 'reselect'
import { removeEmptyKeys } from 'client/contexts/Tracking/utils'
import { FILTERS_STATE } from './constants'
import type { FiltersState } from './state'

export const getFacilities = (state: Record<typeof FILTERS_STATE, FiltersState>) =>
  state[FILTERS_STATE]?.facilities
export const getIsFamilyFriendly = (state: Record<typeof FILTERS_STATE, FiltersState>) =>
  state[FILTERS_STATE]?.family
export const getOrderBy = (state: Record<typeof FILTERS_STATE, FiltersState>) =>
  state[FILTERS_STATE]?.orderBy
export const getStars = (state: Record<typeof FILTERS_STATE, FiltersState>) =>
  state[FILTERS_STATE]?.stars
export const getAccommodationTypes = (state: Record<typeof FILTERS_STATE, FiltersState>) =>
  state[FILTERS_STATE]?.accommodationTypes
export const getRating = (state: Record<typeof FILTERS_STATE, FiltersState>) =>
  state[FILTERS_STATE]?.rating
export const getMinPrice = (state: Record<typeof FILTERS_STATE, FiltersState>) =>
  state[FILTERS_STATE]?.minPrice
export const getMaxPrice = (state: Record<typeof FILTERS_STATE, FiltersState>) =>
  state[FILTERS_STATE]?.maxPrice
export const getThemes = (state: Record<typeof FILTERS_STATE, FiltersState>) =>
  state[FILTERS_STATE]?.themes
export const getBoards = (state: Record<typeof FILTERS_STATE, FiltersState>) =>
  state[FILTERS_STATE]?.boards
export const getPaymentOptions = (state: Record<typeof FILTERS_STATE, FiltersState>) =>
  state[FILTERS_STATE]?.paymentOptions
export const getCancellationPolicies = (state: Record<typeof FILTERS_STATE, FiltersState>) =>
  state[FILTERS_STATE]?.cancellationPolicies

export const getFilters = createSelector(
  [
    getIsFamilyFriendly,
    getFacilities,
    getOrderBy,
    getStars,
    getAccommodationTypes,
    getRating,
    getMinPrice,
    getMaxPrice,
    getThemes,
    getBoards,
    getPaymentOptions,
    getCancellationPolicies,
  ],
  (
    family,
    facilities,
    orderBy,
    stars,
    accommodationTypes,
    rating,
    minPrice,
    maxPrice,
    themes,
    boards,
    paymentOptions,
    cancellationPolicies
  ) => {
    return removeEmptyKeys({
      family,
      facilities,
      orderBy,
      stars,
      accommodationTypes,
      rating,
      minPrice,
      maxPrice,
      themes,
      boards,
      paymentOptions,
      cancellationPolicies,
    })
  }
)

export const getSetFiltersCount = createSelector(
  [
    getIsFamilyFriendly,
    getFacilities,
    getStars,
    getAccommodationTypes,
    getRating,
    getMinPrice,
    getMaxPrice,
    getThemes,
    getBoards,
    getPaymentOptions,
    getCancellationPolicies,
  ],
  (
    family,
    facilities,
    stars,
    accommodationTypes,
    rating,
    minPrice,
    maxPrice,
    themes,
    boards,
    paymentOptions,
    cancellationPolicies
  ) => {
    const price = [minPrice, maxPrice].filter(v => v !== undefined)

    const filtersApplied = removeEmptyKeys({
      family,
      facilities,
      stars,
      accommodationTypes,
      rating,
      price,
      themes,
      boards,
      paymentOptions,
      cancellationPolicies,
    })

    return Object.keys(filtersApplied).length
  }
)
